<template>
	<transition-group :class="['sliderTransition']"
					  name="slider"
					  tag="div"
					  v-on="$listeners">
		<slot></slot>
	</transition-group>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Provide } from "vue-property-decorator";

@Component
export default class SliderTransition extends Vue {
}
</script>

<style lang="scss">
	.sliderTransition {
		display: flex;
		flex-direction: column-reverse;
		position: relative;
		height: 100%;
	}

	.slider-enter-active,
	.slider-leave-active {
		transition-duration: 250ms;
		transition-property: opacity, transform;
		opacity: 1;
		transform: translateX(0);

		&:first-child {
			transition-property: opacity;
		}
	}

	.slider-enter,
	.slider-leave-to {
		opacity: 0;
		transform: translateX(100%);
		will-change: transform;
	}
</style>